import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Dialog } from 'primereact/dialog'
import { LuxButton, LuxSelect, Color } from '@lux/wardrobe-lib'
import { FiltersService } from '@/app/services/FiltersService'
import './DialogCancelVisit.scss'

const DialogCancelVisit = (props: {
    dialogVisible: boolean
    onHide: () => void
    onConfirm: (macroReason: string, reason: string) => void
}) => {
    const { dialogVisible, onHide, onConfirm } = props

    const componentClass = 'smart-modals-dialog-cancel-visit'

    const [macroReasonList, setMacroreasonList] = useState([])
    const [reasonList, setReasonList] = useState([])
    const [macroReason, setMacroreason] = useState('')
    const [reason, setReason] = useState('')

    const intl = useIntl()

    useEffect(() => {
        FiltersService.GetCancelVisitReasons().then((res) => {
            setMacroreasonList(res.data.macroreasons)
        })
    }, [])

    useEffect(() => {
        if (macroReason) {
            setReasonList(macroReasonList.find((m) => m.name === macroReason)?.reasons)
        }
    }, [macroReason])

    const renderFooter = () => {
        return (
            <div className={`${componentClass}-buttons`}>
                <LuxButton
                    onClick={() => null}
                    text={intl.formatMessage({
                        id: 'modals.activity.visit.cancel.back',
                        defaultMessage: 'Back',
                    })}
                    variant="outlined"
                />
                <LuxButton
                    onClick={() => onConfirm(macroReason, reason)}
                    text={intl.formatMessage({
                        id: 'modals.activity.visit.cancel.confirm',
                        defaultMessage: 'Confirm',
                    })}
                    color={Color.WARNING}
                />
            </div>
        )
    }

    return (
        <Dialog
            header={intl.formatMessage({
                id: 'modals.activity.visit.cancel',
                defaultMessage: 'Cancel Visit',
            })}
            draggable={false}
            visible={dialogVisible}
            onHide={() => onHide()}
            footer={renderFooter()}
            style={{ width: '50vw' }}
            maskClassName={componentClass}
            breakpoints={{ '960px': '85vw' }}>
            <div>
                <div className={`${componentClass}-description text`}>
                    {intl.formatMessage({
                        id: 'modals.activity.visit.cancel.description',
                        defaultMessage: 'To continue, select Reasons',
                    })}
                </div>
            </div>
            <div className={`${componentClass}-content`}>
                <div className={`${componentClass}-select`}>
                    <LuxSelect
                        value={macroReason}
                        onChangeCallback={setMacroreason}
                        options={macroReasonList}
                        placeholder={intl.formatMessage({
                            id: 'modals.activity.visit.cancel.macroreason',
                            defaultMessage: 'Select Macroreason',
                        })}
                        additionalProps={{
                            optionValue: 'name',
                            optionLabel: 'name',
                        }}
                    />
                </div>
                <div className={`${componentClass}-select`}>
                    <LuxSelect
                        value={reason}
                        disabled={!macroReason}
                        onChangeCallback={setReason}
                        options={reasonList}
                        placeholder={intl.formatMessage({
                            id: 'modals.activity.visit.cancel.reason',
                            defaultMessage: 'Select Reason',
                        })}
                    />
                </div>
            </div>
        </Dialog>
    )
}

export default DialogCancelVisit
